export const DateOptions = [
    { label: 'All', value: 'All', description: 'All records' },
    { label: 'Today', value: 'Today', description: 'Today Midnight to current time' },
    { label: 'Yesterday', value: 'Yesterday', description: 'Previous Day' },
    // { label: 'Tommorow', value: 'Tommorow', description: 'Today midnight unitl the current time' },
    { label: 'This Week', value: 'This Week', description: 'From Current week start to Current time' },
    { label: 'Last Week', value: 'Last Week', description: 'Last week start to Last week end' },
    { label: 'This Month', value: 'This Month', description: 'From Current Month start to Current time' },
    { label: 'Last Month', value: 'Last Month', description: 'Last Month start to Last Month end' },
    { label: '3MTD', value: '3MTD', description: 'Past Three months from Current time' },
    { label: 'Custom', value: 'Custom', description: 'Time between the selected date range' },
]

export const CellWidth = 230;
export const MinimumCellWidth = 140;